import { serialize } from 'object-to-formdata';

export const serializeToFormData = <T>(data: T) => {
    return serialize(data, {
        indices: false,
        nullsAsUndefineds: false,
        booleansAsIntegers: false,
        allowEmptyArrays: false
    });
};
